import sImg1 from '../images/services/service_image_1.webp'
import sImg2 from '../images/services/service_image_2.webp'
import sImg3 from '../images/services/service_image_3.webp'
import sImg4 from '../images/services/service_image_4.webp'
import sImg5 from '../images/services/service_image_5.webp'

import icon1 from '../images/icons/icon_code.svg'
import icon2 from '../images/icons/icon_programming_tree.svg'
import icon3 from '../images/icons/icon_monitor_2.svg'
import icon4 from '../images/icons/icon_phone.svg'
import icon5 from '../images/icons/icon_bug.svg'

import { applyServiceSeo } from './serviceSeo'

const highLevelServices = [
    {
        Id: '1',
        sImg: sImg1,
        title: 'Managed IT Services',
        slug: 'Managed-IT-Services',
        thumb1: 'Operations',
        thumb2: 'Support',
        col: 'col-lg-6',
        description: 'Reliable IT management, monitoring, support, vendor coordination, and technology planning for growing businesses.',
        features: ['IT operations management', 'User and device support', 'Vendor and asset coordination', 'Technology roadmap planning'],
        details: {
            overview: 'Managed IT Services help your business keep systems stable, secure, and aligned with daily operations. Krit Cloud Platforms Sdn Bhd supports infrastructure, users, vendors, and technology planning under one practical service model.',
            approach: 'We review your current environment, identify support gaps, improve service routines, and create a manageable roadmap for systems, security, and user support.',
            outcomeIntro: 'Your team gains a clearer IT operating model with faster support, better visibility, and less day-to-day technology friction.',
        },
        outcomes: ['Improved system reliability', 'Faster support response', 'Clearer asset visibility', 'Better vendor coordination', 'Reduced operational risk', 'Scalable IT planning'],
    },
    {
        Id: '2',
        sImg: sImg2,
        title: 'Cloud & Infrastructure Services',
        slug: 'Cloud-and-Infrastructure-Services',
        thumb1: 'Cloud',
        thumb2: 'Infrastructure',
        col: 'col-lg-6',
        description: 'Cloud migration, infrastructure setup, monitoring, backup, recovery, and cost optimization in one service line.',
        features: ['Cloud migration planning', 'Infrastructure setup', 'Backup and disaster recovery', 'Cloud monitoring and cost review'],
        details: {
            overview: 'Cloud & Infrastructure Services bring together the core work needed to run modern systems securely and efficiently. We help businesses move workloads, configure cloud foundations, monitor environments, and protect critical data.',
            approach: 'We assess existing systems, plan migration or infrastructure improvements, configure cloud services, validate security baselines, and hand over clear operational documentation.',
            outcomeIntro: 'Your business gets a dependable cloud and infrastructure foundation that can scale without unnecessary complexity.',
        },
        outcomes: ['Safer cloud adoption', 'More reliable infrastructure', 'Improved backup readiness', 'Better cost visibility', 'Stronger monitoring', 'Clearer operational ownership'],
    },
    {
        Id: '3',
        sImg: sImg3,
        title: 'Cybersecurity & Compliance',
        slug: 'Cybersecurity-and-Compliance',
        thumb1: 'Security',
        thumb2: 'Governance',
        col: 'col-lg-4',
        description: 'Security assessments, access control, cloud security monitoring, compliance readiness, and governance support.',
        features: ['Security posture reviews', 'Identity and access management', 'Cloud security monitoring', 'Compliance and governance planning'],
        details: {
            overview: 'Cybersecurity & Compliance helps protect business systems, data, and users while improving readiness for audits and governance requirements.',
            approach: 'We review access, configuration, exposure, monitoring, policy gaps, and operational controls. Then we prioritize practical fixes that reduce risk without slowing down the business.',
            outcomeIntro: 'Leadership receives a clearer view of technology risk and a realistic plan for stronger controls.',
        },
        outcomes: ['Lower security exposure', 'Better access governance', 'Improved audit readiness', 'Clear risk priorities', 'Stronger cloud monitoring', 'Practical compliance controls'],
    },
    {
        Id: '4',
        sImg: sImg4,
        title: 'Custom Software Development',
        slug: 'Custom-Software-Development',
        thumb1: 'Software',
        thumb2: 'Systems',
        col: 'col-lg-4',
        description: 'Custom business systems, portals, integrations, APIs, SaaS products, and legacy modernization.',
        features: ['Business application development', 'API and database integration', 'SaaS product development', 'Legacy application modernization'],
        details: {
            overview: 'Custom Software Development creates systems that fit the way your business works. We build applications, portals, workflows, APIs, and data-driven tools around real operational needs.',
            approach: 'We define requirements, design architecture, build in focused phases, test with user scenarios, and support release improvements after launch.',
            outcomeIntro: 'Your team receives software that reduces manual work, connects data, and supports long-term growth.',
        },
        outcomes: ['Better process fit', 'Reduced manual work', 'Integrated systems', 'Secure user access', 'Maintainable codebase', 'Scalable application architecture'],
    },
    {
        Id: '5',
        sImg: sImg5,
        title: 'Web & Mobile App Development',
        slug: 'Web-and-Mobile-App-Development',
        thumb1: 'Web Apps',
        thumb2: 'Mobile Apps',
        col: 'col-lg-4',
        description: 'Responsive web applications, customer portals, Android and iOS apps, and cross-platform mobile products.',
        features: ['Web application development', 'Customer and staff portals', 'Android and iOS app delivery', 'Cross-platform mobile apps'],
        details: {
            overview: 'Web & Mobile App Development covers browser-based tools and mobile experiences for customers, staff, and operations teams.',
            approach: 'We plan user journeys, design responsive interfaces, build secure application features, connect APIs, and test across target devices and browsers.',
            outcomeIntro: 'Your business gets digital products that are easier to use, easier to maintain, and ready for real users.',
        },
        outcomes: ['Better customer access', 'Responsive user experience', 'Mobile-ready workflows', 'Secure app integrations', 'Improved service delivery', 'Reusable digital platforms'],
    },
    {
        Id: '6',
        sImg: icon1,
        title: 'Data Analytics & Business Intelligence',
        slug: 'Data-Analytics-and-Business-Intelligence',
        thumb1: 'Analytics',
        thumb2: 'Reporting',
        col: 'col-lg-4',
        description: 'Dashboards, reporting, data pipelines, warehouses, Power BI, and analytics platforms for clearer decisions.',
        features: ['Business intelligence dashboards', 'Power BI reporting', 'Data pipelines and warehouses', 'Analytics platform implementation'],
        details: {
            overview: 'Data Analytics & Business Intelligence turns scattered business data into reliable reporting, dashboards, and decision-ready insights.',
            approach: 'We define KPIs, review data sources, model trusted datasets, build dashboards, and improve reporting governance for business users.',
            outcomeIntro: 'Leaders and teams gain clearer performance visibility and more confidence in the numbers they use.',
        },
        outcomes: ['Clearer KPI tracking', 'Trusted reporting data', 'Faster management decisions', 'Reduced spreadsheet dependency', 'Role-based dashboards', 'Improved data governance'],
    },
    {
        Id: '7',
        sImg: icon2,
        title: 'CRM & Business Applications',
        slug: 'CRM-and-Business-Applications',
        thumb1: 'CRM',
        thumb2: 'Apps',
        col: 'col-lg-4',
        description: 'CRM workflows, internal business applications, customer data models, sales pipelines, and reporting.',
        features: ['CRM workflow design', 'Sales and service pipelines', 'Customer data structure', 'Business application configuration'],
        details: {
            overview: 'CRM & Business Applications help teams manage customer relationships, sales activity, service follow-ups, and internal workflows in a more organized way.',
            approach: 'We map customer journeys, define roles and data fields, configure workflows, automate follow-ups, and connect reports that managers can use.',
            outcomeIntro: 'Your business gains cleaner customer visibility and more consistent team execution.',
        },
        outcomes: ['Better customer visibility', 'Cleaner sales pipeline data', 'More consistent follow-ups', 'Improved team accountability', 'Useful CRM reporting', 'Reduced manual tracking'],
    },
    {
        Id: '8',
        sImg: icon3,
        title: 'AI & Process Automation',
        slug: 'AI-and-Process-Automation',
        thumb1: 'AI',
        thumb2: 'Automation',
        col: 'col-lg-4',
        description: 'AI chatbots, customer support automation, document processing, and workflow automation for repetitive tasks.',
        features: ['Process automation planning', 'AI chatbot development', 'Document processing automation', 'Support workflow automation'],
        details: {
            overview: 'AI & Process Automation helps businesses reduce repetitive work, speed up support, and create smarter workflows across teams.',
            approach: 'We identify repeatable processes, define automation rules, design AI-assisted flows, integrate business systems, and measure operational improvement.',
            outcomeIntro: 'Teams spend less time on manual tasks and more time on higher-value work.',
        },
        outcomes: ['Reduced manual effort', 'Faster response times', 'Fewer process errors', 'Improved document handling', 'Better support consistency', 'Measurable efficiency gains'],
    },
    {
        Id: '9',
        sImg: icon4,
        title: 'IT Consulting & Digital Transformation',
        slug: 'IT-Consulting-and-Digital-Transformation',
        thumb1: 'Consulting',
        thumb2: 'Strategy',
        col: 'col-lg-4',
        description: 'Technology strategy, digital transformation roadmaps, process optimization, change planning, and execution support.',
        features: ['Digital transformation roadmap', 'Technology strategy', 'Business process optimization', 'Change and execution planning'],
        details: {
            overview: 'IT Consulting & Digital Transformation helps leaders choose the right technology direction and turn ideas into practical improvement programs.',
            approach: 'We review current operations, identify business priorities, compare technology options, design a roadmap, and support phased execution.',
            outcomeIntro: 'Your organization gets a clearer path for modernization, investment, and adoption.',
        },
        outcomes: ['Clearer digital roadmap', 'Better technology investment', 'Improved process efficiency', 'Aligned stakeholders', 'Reduced transformation risk', 'Practical execution plan'],
    },
    {
        Id: '10',
        sImg: icon5,
        title: 'Maintenance & Support',
        slug: 'Maintenance-and-Support',
        thumb1: 'Maintenance',
        thumb2: 'Support',
        col: 'col-lg-4',
        description: 'Post-launch support, bug fixes, monitoring, enhancements, performance improvements, and technical advisory.',
        features: ['Application maintenance', 'Bug fixing and enhancements', 'Performance monitoring', 'Post-launch technical support'],
        details: {
            overview: 'Maintenance & Support keeps websites, applications, cloud environments, and business systems stable after launch.',
            approach: 'We review support needs, define priorities, monitor issues, resolve defects, deploy improvements, and advise on next-step enhancements.',
            outcomeIntro: 'Your digital systems remain more reliable, secure, and useful as business needs change.',
        },
        outcomes: ['Less downtime', 'Faster issue resolution', 'Improved user confidence', 'Controlled enhancement backlog', 'Better performance', 'Longer system lifespan'],
    },
];

const Services = applyServiceSeo(highLevelServices);

export default Services;
